<template lang="pug">
.container-page
  .erip-content
    .flex
      .erip-img
        img(src="~@/assets/img/erip.jpg")
        br
        span Номер вашего заказа:
        br
        span.bold {{orderId}}
      .erip-desc
        p
          strong ЕРИП
          |  - оплата банковскими платежными карточками в мобильном банкинге,
          | электронными и наличными денежными средствами в системах дистанционного
          | банковского обслуживания и кассах

        br
        p.rules Для проведения платежа Вам необходимо:
          ol
            li  1. Выбрать пункт «Система "Расчет" (ЕРИП)»
            li  2. Выбрать пункт «Билеты, Лотереи», далее "Билетные операторы",
              | а затем «24guru.by-Афиша,Билеты,Скидки»
            li  3. Ввести номер заказа билетов. &nbsp;
              strong Ваш номер -
                span.clr  {{orderId}}
            li  4. Подтвердить оплату
        br
        p
          strong Внимание!
        p С момента выбора способа оплаты "ЕРИП", у Вас 15 минут на совершение оплаты через
         | интернет, инфокиоск или через банкомат.
        p Если у Вас не получается оплатить заказ, возможно отведенное для оплаты время закончилось.
        br
        p.sub-help При оплате в кассе любого банка (участника системы «Расчет» (ЕРИП)) сообщаете,
          | что вам необходимо оплатить услугу «24guru.by-Афиша,Билеты,Скидки» через систему
          | «Расчет»
          | (услуга размещена в каталоге «Билеты, Лотереи»/Билетные операторы)
          | и сообщаете "Номер заказа билетов".
        br
        span
          router-link.btn.button_primary-outline(:to="'/tickets'") Билеты
</template>

<script>
export default {
  props: ['orderId'],
};
</script>

<style lang="scss">
.erip-content{
  font-size: .8rem;
  padding: .5rem;
  line-height: 1.2rem;
  .erip-img {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 200px;
    border-right: 1px #efefef solid;
    img {
      width: 180px;
    }
    .bold{
      font-weight: 700;
      font-size: 2rem;
    }
  }
  .erip-desc {
    padding: 0 2rem;
  }
  .rules{
    font-size: 1rem;
  }
  .flex{
    display: flex;
    justify-content: space-between;

    p{
      font-size: 1rem;
      line-height: 2rem;
      max-width: 80%;
    }
  }
  li{
    padding: .5rem 2rem;
    .clr{
      color: #6400ac;
    }
  }
  p.sub-help {
    color: #999;
    font-size: .8rem;
    line-height: 1rem;
    font-weight: 400;
  }
  .info {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    text-align: center;

  }
}
</style>
